module.exports = __webpack_public_path__ + "static/media/confirm-plan-android.7b77dae8.webp";